export const pricingPlans = [
  {
    id: 6,
    pricingId: 6,
    name: 'Free Trial',
    planCode: 'FREETRIAL',
    price: 0,
    priceDisplay: 'Free',
    currency: 'USD',
    currencySymbol: '$',
    period: '',
    description: 'One-time 7-day free trial with 60 recording minutes.',
    buttonText: 'Go Free',
    features: [
      '7 days free access',
      '60 total recording minutes',
      '15 minutes per conversation',
      'Live transcription',
      'AI-powered summarization',
      'Basic note organization',
      'Image & multimedia notes',
      'Rich text formatting & editing',
      'iOS & Android app access'
    ],
    popular: false,
    color: 'from-emerald-500 to-emerald-600'
  },
  {
    id: 1,
    pricingId: 2001,
    name: 'Basic',
    planCode: 'BAS',
    price: 9,
    priceDisplay: '$9',
    currency: 'USD',
    currencySymbol: '$',
    period: 'per month',
    description: 'Perfect for individual users getting started',
    buttonText: 'Get started',
    features: [
      'Live transcription',
      'AI-powered summarization',
      'Basic note organization',
      'Audio to text (2 hours/month)',
      'Image & multimedia notes',
      'Rich text formatting & editing',
      'Note sharing via link',
      'iOS & Android app access',
      'Email support'
    ],
    popular: false,
    color: 'from-blue-500 to-blue-600',
    billingCycle: 'MONTHLY',
    isYearly: false
  },
  {
    id: 2,
    pricingId: 2002,
    name: 'Professional',
    planCode: 'PRO',
    price: 19,
    priceDisplay: '$19',
    currency: 'USD',
    currencySymbol: '$',
    period: 'per month',
    description: 'Ideal for professionals and small teams',
    buttonText: 'Buy now',
    features: [
      'Advanced search & categorization',
      'Prioritized support',
      'Audio to text (20 hours/month)',
      'Auto-delete & Manual text',
      'Audio playback with speed control'
    ],
    includesText: 'Everything in Basic, plus',
    popular: true,
    color: 'from-purple-500 to-purple-600',
    billingCycle: 'MONTHLY',
    isYearly: false
  },
  
  // Yearly Plans
  {
    id: 4,
    pricingId: 2004,
    name: 'Basic',
    planCode: 'BAS-ANN',
    price: 99,
    priceDisplay: '$99',
    currency: 'USD',
    currencySymbol: '$',
    period: 'per year',
    description: 'Perfect for individual users getting started',
    buttonText: 'Get started',
    features: [
      'Live transcription',
      'AI-powered summarization',
      'Basic note organization',
      'Audio to text (24 hours/year)',
      'Image & multimedia notes',
      'Rich text formatting & editing',
      'Note sharing via link',
      'iOS & Android app access',
      'Email support'
    ],
    popular: false,
    color: 'from-blue-500 to-blue-600',
    billingCycle: 'YEARLY',
    isYearly: true
  },
  {
    id: 5,
    pricingId: 2005,
    name: 'Professional',
    planCode: 'PRO-ANN',
    price: 190,
    priceDisplay: '$190',
    currency: 'USD',
    currencySymbol: '$',
    period: 'per year',
    description: 'Ideal for professionals and small teams',
    buttonText: 'Buy now',
    features: [
      'Advanced search & categorization',
      'Prioritized support',
      'Audio to text (240 hours/year)',
      'Auto-delete & Manual text',
      'Audio playback with speed control'
    ],
    includesText: 'Everything in Basic, plus',
    popular: true,
    color: 'from-purple-500 to-purple-600',
    billingCycle: 'YEARLY',
    isYearly: true
  },
  {
    id: 3,
    pricingId: 2003,
    name: 'Enterprise',
    planCode: 'ENT',
    price: null,
    priceDisplay: 'Contact Sales',
    currency: 'USD',
    currencySymbol: '$',
    period: '',
    description: 'For large teams and organizations',
    buttonText: 'Contact Sales',
    features: [
      'Unlimited team members',
      'Advanced analytics & insights',
      'Custom integrations',
      'Dedicated account manager',
      'SSO authentication',
      'Unlimited audio to text',
      'API access'
    ],
    includesText: 'Everything in Professional, plus',
    popular: false,
    color: 'from-indigo-500 to-indigo-600'
  }
];

export const getMonthlyEquivalent = (yearlyPrice) => {
  if (yearlyPrice === null || yearlyPrice === undefined) return '';
  const monthlyValue = (yearlyPrice / 12).toFixed(2);
  return `$${monthlyValue}`;
};

export const getSavePercentage = (yearlyPrice, monthlyPrice) => {
  if (yearlyPrice === null || monthlyPrice === null) return '';
  const annualMonthlyTotal = monthlyPrice * 12;
  const savings = ((annualMonthlyTotal - yearlyPrice) / annualMonthlyTotal) * 100;
  return `${Math.round(savings)}%`;
};
